'use client';

import { useUser } from '@/store';
import { useEffect } from 'react';
import { icons } from '@/Icons';

interface Input_CheckBoxProps {
	attestation: boolean;
	setAttestation: (attestation: boolean) => void;
}

const Input_CheckBox_Attestation = ({
	attestation,
	setAttestation,
}: Input_CheckBoxProps) => {
	const user = useUser();

	useEffect(() => {
		if (user?.moreDetails?.attestation) {
			setAttestation(true);
		}
	}, [user]);

	return (
		<>
			<label className="flex gap-5 text-sm text-dove-white-o-70">
				<div className="relative flex items-center justify-center min-w-[18px] w-[18px] h-[18px] my-2.5 ">
					<input
						id="attestation"
						name="attestation"
						type="checkbox"
						className="invisible peer "
						checked={attestation}
						onChange={(e) => setAttestation(e.target.checked)}
					/>{' '}
					<div className="absolute inset-0 bg-transparent peer-checked:bg-tokens-alert rounded border-2 border-tokens-alert"></div>
					<svg
						className="absolute inset-0 m-auto w-2.5 h-2.5 text-white hidden peer-checked:block"
						xmlns="http://www.w3.org/2000/svg"
						width="12"
						height="9"
						viewBox="0 0 12 9"
						fill="none"
					>
						<path
							d="M1.5 5.2L4.35714 8L10.5 1"
							stroke="#F2F3F5"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<div className="flex-1 flex gap-2.5 p-2.5 bg-tokens-alert-o-20 rounded-lg leading-[150%]">
					<icons.circleinfo className="w-5 h-5 text-tokens-alert" />
					<div className="flex-1 text-tokens-alert">
						<p>I hereby declare under penalty of perjury that:</p>
						<ul className="list-disc ml-4">
							<li className="font-bold">
								I am not a U.S. citizen or resident.
							</li>
							<li>
								<span className="font-bold">I am not using a VPN</span> to
								access this site from the U.S. or any other country where
								prohibited by law.
							</li>
						</ul>
					</div>
				</div>
			</label>
		</>
	);
};

export default Input_CheckBox_Attestation;
